import { ClientEvents } from 'common/events/ClientEvents';
import React from 'react';
import { useChatContext } from 'src/chat/hooks/useChatContext';
import { Menu } from 'src/shared/design-system/Icon';
import { useModal } from 'src/shared/hooks/useModal';
import { useTracker } from 'src/shared/hooks/useTracker';
import { AccountSettingsModal } from '../../AccountSettingsModal/AccountSettingsModal';
import { useHideNavbar } from '../../DishFirstHeader/store';
import { NavItemIcon, UnreadIndicator } from '../RightNav/styles';

export const HamburgerMenu: React.FC = () => {
  const { isShowing, hide, show } = useModal();
  const tracker = useTracker();
  const { unread } = useChatContext();

  const { hideAll } = useHideNavbar();

  const handleClick = () => {
    hideAll();
    show();
    tracker.track(ClientEvents.NAV_CLICK, { elementName: 'hamburger' });
  };

  return (
    <>
      <NavItemIcon onClick={handleClick} data-cy='hamburger-menu'>
        <Menu height='24px' width='24px' />
        {unread > 0 && <UnreadIndicator />}
      </NavItemIcon>
      <AccountSettingsModal isShowing={isShowing} hide={hide} />
    </>
  );
};
